<template>
  <a-modal
    title="申请退款"
    :width="600"
    :dialog-style="{ top: '20px' }"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-alert type="warning">
      <span slot="message">
        财务处理周期约20个工作日左右，请您耐心等待，费用会退回您支付时的原账户。
      </span>
    </a-alert>
    <br>
    <a-alert type="error" v-if="disableRefund" message="未开放退款"></a-alert>
    <br>
    <p v-if="eventApplyInfo.event">活动： {{eventApplyInfo.event.eventName}}</p>
    <p v-if="eventApplyInfo.categoryParent">赛项： {{eventApplyInfo.categoryParent.name}}</p>
    <p v-if="eventApplyInfo.category">组别： {{eventApplyInfo.category.name}}</p>
    <p>订单号：{{ orderInfo.orderNo }}</p>
    <p>金额：{{ orderInfo.payPrice / 100 }}</p>
    <p>请填写退款理由：</p>
    <a-textarea v-model="comment"> </a-textarea>
    <a-button
      type="primary"
      style="display: block; margin: 20px auto; width: 200px"
      size="large"
      @click="handleOk"
      :disabled="disableRefund"
      >确认申请退款</a-button>
  </a-modal>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
export default {
  name: "RefundModal",
  mixins: [],
  components: {},
  data() {
    return {
      visible: false,
      orderInfo: {},
      eventApplyInfo: {},
      comment: "",
      disableRefund: true
    };
  },
  created() {},
  methods: {
    refund(order) {
      this.visible = true;
      this.disableRefund = true
      this.orderInfo = order;
      console.log(order);
      this.getEventApplyInfo(this.orderInfo.eventApplyIds)
    },
    getEventApplyInfo(id){
      getAction("/teaching/teachingEventApply/getApplyInfo?eventApplyId="+id).then(res=>{
        if(res.success){
          this.eventApplyInfo = res.result
          if(this.eventApplyInfo.event && this.eventApplyInfo.event.applyConfig){
            this.disableRefund = !this.eventApplyInfo.canRefund
          }
        }else{
           this.$message.info(res.message);
        }
      })
    },
    handleOk() {
      if(!this.orderInfo) return;
      if(this.comment  == ""){
        this.$message.info("请填写退费原因");
        return
      }
      if(this.disableRefund){
        this.$message.info("未开放退费");
        return;
      }
      getAction("/teaching/teachingOrder/refundApply",{orderNo: this.orderInfo.orderNo, comment: this.comment}).then(res=>{
        if(res.success){
          this.$message.info(res.message);
          this.visible = false
          this.$emit("ok")
        }else{
          this.$message.info(res.message);
        }
      })
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
</style>